import React, { ReactElement, ForwardedRef } from 'react';
import TableInternal from '@mui/material/Table';
import FormatService from '../../services/format-service';
import useStylesTable from './table.styles';

const Table: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLTableElement>,
): ReactElement => {
  const {
    isFullWidth,
    withStickyHeader,
    minWidth,
    className,
    children,
  } = props;

  const stylesProps: MaterialUIStylesProps = {
    minWidth,
  };

  const { classes } = useStylesTable(stylesProps);

  const fullWidthClassName: string | undefined = isFullWidth ? classes.tableFullWidth : undefined;

  return (
    <TableInternal
      ref={ref}
      stickyHeader={withStickyHeader}
      className={FormatService.formatClassNames(classes.table, fullWidthClassName, className)}
    >
      {children}
    </TableInternal>
  );
}));

export default Table;
